<template>
    <div class="undoTransfer modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container-fluid">
              <div class="row">
                <div class="col-9 col-sm-5 col-lg-5 my-auto">
                  <h5 class="modal-title" id="undoTransferLabel">Undo Transfer</h5>
                </div>
                <div class="col-3 col-sm-7 my-auto">
                    <div>
                        <div>
                            <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal" aria-label="Close"></i></a></span>
                        </div>
                        <div>
                            <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                <span class="fa-stack fa-2x fsm float-right">
                                    <i class="far fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                </span>
                            </router-link> -->
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-12 my-auto">
                      <p class="d-inline">1 - Please wait while we check:</p><!-- This is the service identifier for the one the user chose--><p class="d-inline font-weight-bold ml-1">202409003</p>
                      <img src="@/assets/img/loading.png" class="ml-4" alt="loading icon">
                    </div>
                  </div>
                  <!-- Step 2 and 3 dont't show until all checks have been done -->
                  <div class="row">
                    <div class="col-12 my-auto">
                      <p class="d-inline">2 - Check complete</p>
                      <img src="@/assets/img/tick_selector.png" class="ml-4" alt="tick icon">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 my-auto">
                      <p class="mt-2">3 - Are you sure you want to undo the transfer?</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-4">
                      <div class="col-sm-12 col-md-6 d-inline">
                        <a class="btn btn-hc btn-xs-block btn-sm-block float-left w-40" role="button">Yes</a>
                      </div>
                      <div class="col-sm-12 col-md-6 d-inline">
                        <a class="btn btn-hc btn-xs-block btn-sm-block float-right w-40" role="button">No</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
          date: moment(),
    }
  }
}
</script>
